/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll("[data-slide]").forEach(function(slide) {
      new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.target.classList.contains("media--hidden")) {
            const deferred = mutation.target.querySelector("deferred-media[loaded]");
            if (deferred) {
              const video = deferred.querySelector("video");
              if (video) { video.pause(); video.remove(); }
              deferred.removeAttribute("loaded");
            }
          }
        });
      }).observe(slide, { attributes: true, attributeFilter: ["class"] });
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();